var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 361.89 113.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15a29;}.cls-2{fill:url(#Naamloos_verloop_37);}.cls-3{fill:url(#Naamloos_verloop_47);}.cls-4{fill:url(#Naamloos_verloop_47-2);}.cls-5{fill:url(#Naamloos_verloop_47-3);}.cls-6{fill:url(#Naamloos_verloop_47-4);}.cls-7{fill:url(#Naamloos_verloop_47-5);}.cls-8{fill:url(#Naamloos_verloop_47-6);}.cls-9{fill:url(#Naamloos_verloop_47-7);}.cls-10{fill:url(#Naamloos_verloop_47-8);}.cls-11{fill:url(#Naamloos_verloop_47-9);}.cls-12{fill:url(#Naamloos_verloop_47-10);}.cls-13{fill:url(#Naamloos_verloop_47-11);}.cls-14{fill:url(#Naamloos_verloop_47-12);}.cls-15{fill:url(#Naamloos_verloop_47-13);}.cls-16{fill:url(#Naamloos_verloop_47-14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_37",
    x1: -4.53,
    y1: 49.01,
    x2: 331.56,
    y2: 139.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47",
    x1: 14.92,
    y1: -23.63,
    x2: 351.01,
    y2: 66.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-2",
    x1: 9.55,
    y1: -3.58,
    x2: 345.64,
    y2: 86.43,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-3",
    x1: 12.97,
    y1: -16.34,
    x2: 349.06,
    y2: 73.66,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-4",
    x1: 13.16,
    y1: -17.06,
    x2: 349.25,
    y2: 72.95,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-5",
    x1: 16.62,
    y1: -29.97,
    x2: 352.71,
    y2: 60.04,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-6",
    x1: 1.9,
    y1: 24.99,
    x2: 337.99,
    y2: 115,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-7",
    x1: 3.71,
    y1: 18.23,
    x2: 339.8,
    y2: 108.24,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-8",
    x1: 1.96,
    y1: 24.76,
    x2: 338.05,
    y2: 114.77,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-9",
    x1: -2.05,
    y1: 39.75,
    x2: 334.04,
    y2: 129.76,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-10",
    x1: 1.76,
    y1: 25.52,
    x2: 337.85,
    y2: 115.53,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-11",
    x1: 6.02,
    y1: 9.61,
    x2: 342.11,
    y2: 99.62,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-12",
    x1: 9.97,
    y1: -5.14,
    x2: 346.06,
    y2: 84.87,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-13",
    x1: 7.5,
    y1: 4.08,
    x2: 343.59,
    y2: 94.09,
    xlinkHref: "#Naamloos_verloop_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_47-14",
    x1: 7.03,
    y1: 5.83,
    x2: 343.12,
    y2: 95.84,
    xlinkHref: "#Naamloos_verloop_47"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cow1Asset 1logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.22,92.18a2.68,2.68,0,1,0,2.67,2.68A2.68,2.68,0,0,0,359.22,92.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.49,68.38a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,27.49,68.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.8.1H21.21A21.24,21.24,0,0,0,0,21.31V77.24A21.13,21.13,0,0,0,7.25,93.18v15.66a4.24,4.24,0,0,0,2.28,3.76,4.24,4.24,0,0,0,4.4-.27l20-13.88A21.22,21.22,0,0,0,55,77.24V21.31A21.22,21.22,0,0,0,33.8.1ZM33.8,90H31.26l-12.11,8.4-3.4,2.36v-12A12.72,12.72,0,0,1,8.5,77.24V21.31A12.73,12.73,0,0,1,21.21,8.6H33.8A12.71,12.71,0,0,1,46.48,21.31V77.24A12.7,12.7,0,0,1,33.8,90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.61,18.89a2.5,2.5,0,0,0,2.73,2.82A2.43,2.43,0,0,0,213,19v-4.3c0-.73-.27-2.41-2.73-2.41h-5.67a7.51,7.51,0,0,0-2.37.23,10.18,10.18,0,0,0-1.88.72,1.94,1.94,0,0,0-1.73-1h-.42c-1,0-2.73.42-2.73,3.25V38.62c0,2.83,1.71,3.25,2.73,3.25h.42c.86,0,2.3-.46,2.3-3.56V20.48a3.29,3.29,0,0,1,3.48-2.86h3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.05,41.87h10.81c2.37,0,2.62-1.61,2.62-2.3V14.69c0-.73-.26-2.41-2.72-2.41h-.11c-.94,0-2.51.39-2.51,3V36.53h-8.2a4.18,4.18,0,0,1-1-.16c-1.5-.62-2.24-1.91-2.24-3.94V14.69c0-1.54-1-2.41-2.62-2.41a2.5,2.5,0,0,0-2.72,2.83V33a18.64,18.64,0,0,0,.25,2.53C112.15,39.72,115,41.87,119.05,41.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160.57,39.15V2.61c0-1.6-1-2.51-2.73-2.51h-.06c-2.23.23-2.56,1.68-2.56,2.51V36.53h-8.08c-1.85-.68-2.74-1.75-2.74-3.26V21.09c0-.24,0-.57.07-.94a3.4,3.4,0,0,1,3.5-2.53H150c.86,0,2.31-.34,2.52-2.62,0-1.73-.92-2.72-2.52-2.72h-2.15A8.65,8.65,0,0,0,142.41,14a8.92,8.92,0,0,0-3.36,6.66V33.16a7.65,7.65,0,0,0,.59,3.2c1.67,3.66,4.34,5.51,7.91,5.51h10.61C158.88,41.87,160.57,41.61,160.57,39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.7,39.15V39c0-.75-.27-2.51-2.83-2.51h-10.6c-1.84-.68-2.73-1.75-2.73-3.26V20.88a2.07,2.07,0,0,1,.15-.89c.75-1.59,1.66-2.37,2.79-2.37h5.14c1.84.68,2.74,1.75,2.74,3.26v3.58h-5.61c-.85,0-2.31.33-2.51,2.61,0,1.74.91,2.73,2.51,2.73h8.73a2.22,2.22,0,0,0,2.22-2.23V21a7.69,7.69,0,0,0-.58-3.2c-1.68-3.66-4.34-5.51-7.92-5.51h-4.51a10.5,10.5,0,0,0-2.55.36c-3.95,1.64-5.95,4.45-5.95,8.35V33.16a7.86,7.86,0,0,0,.58,3.2c1.68,3.66,4.35,5.51,7.92,5.51h10.6C187,41.87,188.7,41.61,188.7,39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M241.49,34.42V33.9a7.26,7.26,0,0,0-2.33-5.42c-.78-.65-4.31-2.47-10.81-5.57-2-.66-3-1.6-3-2.87,0-.6,0-2.42,4.2-2.42H237c.85,0,2.31-.34,2.51-2.62,0-1.73-.92-2.72-2.51-2.72h-7.25a20.1,20.1,0,0,0-3.33.34c-4.26,1.31-6.43,3.73-6.43,7.21a7.44,7.44,0,0,0,3,6.3c.73.48,4,2.11,9.9,5,2.16.73,3.25,1.62,3.25,2.67l0,.79c-.31,1.31-1.62,1.94-4,1.94h-9.87c-.85,0-2.31.34-2.52,2.62,0,1.73.92,2.72,2.52,2.72h9.66a13.62,13.62,0,0,0,3.09-.33C239.31,40.47,241.49,38.07,241.49,34.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.12,55.66h-4.85a10.22,10.22,0,0,0-10.21,10.21h0V80.52H103.43a.61.61,0,0,0-.19,0h-2.86l-.13.32a2.59,2.59,0,0,0-.15.85c0,.33,0,1.49,0,2.45l-1.61-1.58c-.27-.28-.61-.61-1-1l-.8-.8-2-1.89-.59-.58c-1.09-1-2-2-2.89-2.85s-1.88-1.91-2.73-2.8c-1-1.08-1.68-1.8-2.2-2.44A8.72,8.72,0,0,1,85,68.39l-.09-.29v-.43a18,18,0,0,1,.19-2.81A5.23,5.23,0,0,1,86,62.63a4.51,4.51,0,0,1,2-1.38,8.46,8.46,0,0,1,3-.43c.44,0,.82,0,1.19,0a5.39,5.39,0,0,1,1.42.3,2.9,2.9,0,0,1,1.75,1.4,6.53,6.53,0,0,1,.68,1.9,14.15,14.15,0,0,1,.17,2.11c0,.77,0,1.31,0,1.78a3.07,3.07,0,0,0,.16.86l.13.32h2.92a2,2,0,0,0,2-2V65.83a12.11,12.11,0,0,0-.54-3.72,11.15,11.15,0,0,0-2-3.77A8.82,8.82,0,0,0,96,56a7.51,7.51,0,0,0-2.22-.72V42a10.21,10.21,0,0,0,10-10.19V10.21A10.22,10.22,0,0,0,93.57,0H88.72A10.22,10.22,0,0,0,78.51,10.21V31.77A10.21,10.21,0,0,0,88.47,42V55.18a7.82,7.82,0,0,0-3.11.91,10,10,0,0,0-3.08,2.61,11.75,11.75,0,0,0-2,3.69,13.68,13.68,0,0,0-.68,4.24c0,.7,0,1.47.11,2.29a7.75,7.75,0,0,0,.54,2l.26.59-.51.37a10.62,10.62,0,0,0-4,4.93,18.85,18.85,0,0,0-1,6.5,15.9,15.9,0,0,0,1,5.57,13.87,13.87,0,0,0,2.69,4.51,12.63,12.63,0,0,0,9.6,4.14h4.24a12.43,12.43,0,0,0,4.47-.83,13.79,13.79,0,0,0,3.9-2.33l.67-.57,3.14,3.37a1.2,1.2,0,0,0,.85.36h3.63a1.22,1.22,0,0,0,1.21-1.22,1.23,1.23,0,0,0-.2-.68l0,0c-.51-.62-1.07-1.27-1.66-1.92-.81-.93-1.62-1.78-2.32-2.52s-1.31-1.39-1.56-1.66l-.33-.41.19-.46a8.22,8.22,0,0,0,.55-2c0-.26,0-.53.07-.79h12.67a1.81,1.81,0,0,0,.23,0v1.6h0a10.21,10.21,0,0,0,10.21,10.2h4.85a10.21,10.21,0,0,0,10.2-10.2h0V65.87h0A10.22,10.22,0,0,0,133.12,55.66ZM83.82,31.77V10.21a4.91,4.91,0,0,1,4.9-4.9h4.85a4.9,4.9,0,0,1,4.89,4.9V31.77a4.9,4.9,0,0,1-4.89,4.9H88.72A4.91,4.91,0,0,1,83.82,31.77ZM97.23,90.33h0A7,7,0,0,1,92.59,92H88.35a7.61,7.61,0,0,1-3.55-.79,7,7,0,0,1-2.53-2.07,8.63,8.63,0,0,1-1.46-3,12.37,12.37,0,0,1-.47-3.41A10.4,10.4,0,0,1,81.06,79a6.57,6.57,0,0,1,2.44-3.12l.55-.39L97.89,89.77Zm35.89,2h-4.85a4.9,4.9,0,0,1-4.9-4.9V65.87a4.91,4.91,0,0,1,4.9-4.9h4.85a4.9,4.9,0,0,1,4.89,4.9V87.43A4.89,4.89,0,0,1,133.12,92.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.54,67.94h-5.67a7.84,7.84,0,0,0-2.37.23,10.46,10.46,0,0,0-1.88.72,2,2,0,0,0-1.73-1h-.42c-1,0-2.73.42-2.73,3.25v23.1c0,2.82,1.71,3.25,2.73,3.25h.42c.86,0,2.3-.47,2.3-3.57V76.14a3.27,3.27,0,0,1,3.47-2.86h3.26v1.27a2.51,2.51,0,0,0,2.73,2.83,2.44,2.44,0,0,0,2.62-2.73v-4.3C253.27,69.62,253,67.94,250.54,67.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M220.52,67.89H216a10.5,10.5,0,0,0-2.55.36c-3.95,1.64-5.95,4.45-5.95,8.35V88.78a7.92,7.92,0,0,0,.58,3.2c1.68,3.65,4.35,5.5,7.92,5.5h10.6c.73,0,2.41-.26,2.41-2.72v-.11c0-.75-.27-2.51-2.83-2.51H215.59c-1.85-.68-2.74-1.75-2.74-3.26V76.49a2.07,2.07,0,0,1,.15-.89c.75-1.59,1.66-2.37,2.79-2.37h5.14c1.84.68,2.74,1.75,2.74,3.26v3.58h-5.58c-.85,0-2.31.33-2.51,2.62,0,1.73.91,2.72,2.51,2.72h8.7A2.22,2.22,0,0,0,229,83.19V76.6a7.69,7.69,0,0,0-.58-3.2C226.75,69.74,224.09,67.89,220.52,67.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.53,67.94H152.72a2.32,2.32,0,0,0-.85.11c-.91.09-2,.75-2,3.35V94.08c0,3,1.51,3.46,2.41,3.46h.32c2.36,0,2.61-1.62,2.61-2.31v-22h8.3a3.44,3.44,0,0,1,1.4.25c1.39.71,2.07,1.56,2.07,2.59V94.29c0,2.82,1.71,3.25,2.73,3.25H170c.9,0,2.41-.44,2.41-3.36V77.91a10.7,10.7,0,0,0-.57-4.23C170.33,69.87,167.52,67.94,163.53,67.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M198.15,55.76h-.06c-2.22.24-2.56,1.68-2.56,2.52V92.19h-8.08c-1.84-.68-2.74-1.75-2.74-3.26V76.75c0-.24,0-.58.07-.94a3.41,3.41,0,0,1,3.5-2.53h2.07c.85,0,2.3-.33,2.51-2.62,0-1.73-.92-2.72-2.51-2.72h-2.17a8.67,8.67,0,0,0-5.46,1.73,8.9,8.9,0,0,0-3.35,6.66v12.5A7.73,7.73,0,0,0,180,92c1.68,3.65,4.34,5.51,7.91,5.51h10.61c.72,0,2.41-.27,2.41-2.73V58.28C200.88,56.68,199.88,55.76,198.15,55.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M289.84,68h-.06a3,3,0,0,0-2.3.91c-.16.24-.46.69-4.47,17.06-1.9-5.16-3.16-8.48-3.75-9.81-.49-2.28-1.5-3.44-3-3.44a2.78,2.78,0,0,0-2.08.89c-.25.35-1,2.09-4.8,12.36-2.69-11-3.35-13.54-3.53-14.07-.3-2.59-1.29-3.9-2.93-3.9a2.9,2.9,0,0,0-2.13.74,2.7,2.7,0,0,0-.68,2l0,.07c3.71,15,4.81,19.53,5.29,20.93h0l0,.24c.56,3.75,1.59,5.58,3.13,5.58H269a2.75,2.75,0,0,0,2-1c.2-.33,1-2.19,5.18-13.65,1.79,5,3.19,8.7,4.17,11.05.57,2.41,1.58,3.64,3,3.64h.31a2.8,2.8,0,0,0,2.05-1.07l.07-.1c.12-.21.36-.65,6.49-25.81v-.11C292.3,69.57,291.87,68.42,289.84,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M347.66,84.16h0c-.78-.66-4.31-2.48-10.81-5.58-2-.66-3-1.6-3-2.87,0-.59,0-2.42,4.2-2.42h7.46c.85,0,2.31-.33,2.51-2.62,0-1.73-.91-2.72-2.51-2.72h-7.25a20.1,20.1,0,0,0-3.33.34c-4.26,1.31-6.42,3.74-6.42,7.21a7.42,7.42,0,0,0,3,6.3c.74.48,4,2.12,9.9,5,2.16.73,3.25,1.63,3.25,2.67l0,.8c-.31,1.3-1.62,1.93-4,1.93h-9.87c-.85,0-2.31.34-2.51,2.62,0,1.73.91,2.73,2.51,2.73h9.66a13.6,13.6,0,0,0,3.09-.34c4.28-1.07,6.46-3.46,6.46-7.11v-.53A7.24,7.24,0,0,0,347.66,84.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M301.7,68h-.11c-2.46,0-2.72,1.69-2.72,2.41V95.34c0,.77.31,2.09,2.41,2.3h.52c.9,0,2.41-.37,2.41-2.83V70.87C304.21,68.41,302.64,68,301.7,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M319.16,67.94h-.11c-2.46,0-2.72,1.68-2.72,2.41V98.8a7.69,7.69,0,0,1-.27,2.38c-.61,1.44-1.83,2.14-3.73,2.14h-1.75c-2,.23-2.33,1.54-2.33,2.29v.84a1.28,1.28,0,0,0,.14.63c.18.61.77,1.58,2.58,1.58h1.78a7.83,7.83,0,0,0,5.48-1.89c2.29-1.44,3.44-4.13,3.44-8V71C321.67,68.33,320.1,67.94,319.16,67.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOeno);
export default __webpack_public_path__ + "static/media/logo_oeno.d37dd92c2d8615b6d17a2776e759e631.svg";
export { ForwardRef as ReactComponent };